import React, { useState, useEffect } from 'react';
import { useChatContext } from 'stream-chat-react';
import { ResultsDropdown } from './';
import { SearchIcon } from '../assets';
const ChannelSearch = ({ setToggleContainer }) => {
    const { client, setActiveChannel } = useChatContext();
    const [query, setQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [teamChannels, setTeamChannels] = useState([])
    const [directChannels, setDirectChannels] = useState([])

    useEffect(() => {
        if(!query) {
            setTeamChannels([]);
            setDirectChannels([]);
        }
    }, [query]);

    const getChannels = async (text) => {
            try {
                const channelResponse = client.queryChannels({
                    type: 'team', 
                    name: { $autocomplete: text }, //for auto-completing channel names
                    members: { $in: [client.userID]}}); //including ourself in members
                
                const userResponse = client.queryUsers({
                        id: { $ne: client.userID },
                        name: { $autocomplete: text }
                    })
        
                    const [channels, { users }] = await Promise.all([channelResponse, userResponse]);
                     //instead of adding the above line, we could've just added await before channelResponse & userResponse
                     //But doing so will slow down the process coz only after getting channelResponse, useResponse will be fetched.
                     //Using the above promise, everything will be fetched simultaneously leading to faster response 
        
                    if(channels.length) setTeamChannels(channels);
                    if(users.length) setDirectChannels(users); //DirectChannel is nothing but a user
            } catch (error) {
                setQuery('');
            }
    }

    const onSearch = (e) => {
        e.preventDefault();
        setLoading(true);
        setQuery(e.target.value);
        getChannels(e.target.value);
    }

    const setChannel = (channel) => {
        setQuery('');
        setActiveChannel(channel);
    }

  return (
    <div className="channel-search__container">
        <div className="channel-search__input__wrapper">
            <div className="channel-search__input__icon">
                <SearchIcon />
            </div>
            <input 
                className="channel-search__input__text" 
                placeholder="Search" 
                type="text" 
                value={query}  
                onChange={onSearch}
            />
        </div>
        { query && (
                <ResultsDropdown 
                    teamChannels={teamChannels}
                    directChannels={directChannels}
                    loading={loading}
                    setChannel={setChannel}
                    setQuery={setQuery}
                    setToggleContainer={setToggleContainer}
                />
            )}
    </div>
    
  )
};

export default ChannelSearch;
